module.exports = "/dist//ionicons.ttf?dd4781d1acc57ba4c4808d1b44301201";